import {AccountMin, DiscoveredPortal, Region} from "../../Types";

import jsonApi from "./jsonApi";

export async function listRegions(account: AccountMin) {
  return await jsonApi.get<Region[]>(
    `/region/${account.region}/external_api/accounts/${account.account_id}/portal_discovery/regions`,
  );
}

export async function listPortals(account: AccountMin, region: string) {
  return await jsonApi.get<DiscoveredPortal[]>(
    `/region/${region}/external_api/accounts/${account.account_id}/portal_discovery/portals`,
  );
}
